




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DurasiJamMenit from "./DurasiJamMenit.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { hmToDate, dateToHm } from "@/utility/PartografHelper";

@Component({ components: { DurasiJamMenit, VCDateTimePicker } })
export default class SectionKala4 extends Vue {
  @Prop({ required: true }) value!: any;
  local: any = { rows: [], lama_menit: null, masalah: "", penatalaksanaan: "", hasilnya: "" };

  pukulDate(index: number) {
    const row = this.local.rows[index];
    return row ? hmToDate(row.pukul) : null;
  }

  setPukul(index: number, val: any) {
    const row = this.local.rows[index];
    if (row) this.$set(row, "pukul", dateToHm(val));
  }

  @Watch("value", { immediate: true, deep: true })
  onValueChange(v: any) {
    const vStr = JSON.stringify(v || {});
    if (JSON.stringify(this.local) === vStr) return;
    this.local = JSON.parse(vStr);
  }

  @Watch("local", { deep: true })
  emitInput(v: any) {
    this.$emit("input", v);
  }

  // Suhu diukur hanya di pengukuran pertama tiap jam → baris pertama dari tiap jam_ke
  isSuhuUkur(index: number): boolean {
    if (index === 0) return true;
    const prev = this.local.rows[index - 1];
    const curr = this.local.rows[index];
    return !!(prev && curr && prev.jam_ke !== curr.jam_ke);
  }

  // Baris pertama dari tiap jam_ke (untuk rowspan "Jam ke" column)
  isFirstOfJam(index: number): boolean {
    return this.isSuhuUkur(index);
  }

  rowspanFor(index: number): number {
    const jam = this.local.rows[index].jam_ke;
    let count = 0;
    for (let i = index; i < this.local.rows.length; i++) {
      if (this.local.rows[i].jam_ke !== jam) break;
      count++;
    }
    return count;
  }
}
